"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPricingTypeToString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPricingTypeToString(pricingType) {
    if (pricingType === legacy_enums_1.PricingType.SuperFlexible) {
        return "Super-flexible";
    }
    if (pricingType === legacy_enums_1.PricingType.Flexible) {
        return "Flexible";
    }
    return "Non-refundable";
}
exports.transformPricingTypeToString = transformPricingTypeToString;
//# sourceMappingURL=transformPricingTypeToString.js.map